import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/anime";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <p className="text-sm text-accent-600 font-medium inline-flex items-center gap-2">
            <i className="ri-question-line"></i>
            常见问题
          </p>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">
            关于妖精动漫网
          </h2>
          <p className="mt-4 text-foreground-600 leading-relaxed">
            这里是用户最常问到的一些问题。如果你还有疑问，欢迎通过“关于我们”页面或留言方式联系我们，我们会尽快为你解答。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors"
          >
            了解更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className="rounded-xl border border-background-200 bg-background-100 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base">
                  {f.q}
                </span>
                <span
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all ${
                    open === i ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-200 text-foreground-500"
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              {open === i && (
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}